import o from"./getDisplayName.js";function e(r,t){return`${r}(${o(t)})`}export{e as default};
//# sourceMappingURL=createHocName.js.map
